import React, { useState, useContext, useEffect } from "react";
import { FirebaseContext } from "../context/FirebaseContext";
import { DeleteProducts } from "../utils/deleteProduct";
import {
  collection,
  getDocs,
  writeBatch,
  doc,
  serverTimestamp,
  addDoc,
  query,
  where,
  updateDoc,
} from "firebase/firestore";
import { NavLink } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import TextField from "@mui/material/TextField";

import AlertDialog from "../components/AlertDialog.component";
import EnhancedTableHead from "../components/HeadTable.component";
import AlertBox from "../components/AlertBox.component";
import Spinner from "../components/Spinner.component";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Snackbar from "@mui/material/Snackbar";

const headCells = [
  {
    id: "nameCategorie",
    numeric: false,
    disablePadding: false,
    label: "Nom",
  },
  {
    id: "valueRegister",
    numeric: false,
    center: true,
    disablePadding: false,
    label: "Nombres de Produits",
  },
  {
    id: "colorCategorie",
    numeric: false,

    disablePadding: false,
    label: "Mise en forme",
  },
  {
    id: "editCategorie",
    numeric: false,
    disablePadding: false,
    label: "Editer",
  },
];

function EnhancedTableToolbar(props) {
  const { numSelected, datas, setOpenDialog, setOpenAddDialog } = props;
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
          className="text-2xl max-md:!text-[0.9em]"
        >
          {numSelected} categorie{numSelected > 1 ? "s" : ""} selectionné
          {numSelected > 1 ? "s" : ""}
        </Typography>
      ) : (
        <div className="flex flex-col space-y-1">
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="h6"
            id="tableTitle"
            component="div"
            className="text-2xl max-md:!text-[0.9em]"
          >
            Liste de Catégorie enregistré(s)
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              setOpenAddDialog(true);
            }}
            className="!hidden max-md:!block"
          >
            Ajouter un produit
          </Button>
        </div>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Supprimer">
          <IconButton
            onClick={() => {
              setOpenDialog(true);
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <div className="flex">
          {datas.length > 0 && (
            <Button
              variant="contained"
              className="!block max-md:!hidden"
              onClick={() => {
                setOpenAddDialog(true);
              }}
              sx={{ mr: "10px" }}
            >
              Ajouter un Categorie
            </Button>
          )}
        </div>
      )}
    </Toolbar>
  );
}
EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

function CategoriePage() {
  const DB_CATEGORIE = "categoriesProducts";
  const { db } = useContext(FirebaseContext);
  const categorieRef = collection(db, DB_CATEGORIE);
  const productsRef = collection(db, "products");

  const [selected, setSelected] = React.useState([]);
  const [categoriesList, setCategoriesList] = useState({});
  const [categories, setCategories] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorType, setErrorType] = useState("");
  const [message, setMessage] = useState("");
  const [label, setLabel] = useState("Titre Categorie");
  const [labelID, setLabelID] = useState("");
  const [labelColor, setLabelColor] = useState("#fff");
  const [labelBgColor, setLabelBgColor] = useState("#1976d2");
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [deleteAction, setDeleteAction] = useState(false);
  const [editAction, setEditAction] = useState(false);
  const [error, setError] = useState(false);
  const [addAction, setAddAction] = useState(false);
  const [loading, setLoading] = useState(true);
  const [datas, setDatas] = useState([]);
  const [index, setIndex] = useState(-1);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = categories.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const results = await getDocs(categorieRef)
          .then((s) => {
            fetchRegisterProducts(s).then((result) => {
              setLoading(false);
              return result;
            });
            //return s;
          })
          .catch((e) => {
            console.log(e);
          });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);
  //setRecord(values);

  const fetchRegisterProducts = async (s) => {
    let values = await Promise.all(
      s.docs.map(async (doc) => {
        const q = await query(
          productsRef,
          where("categorieProd", "==", doc.id)
        );

        const querySnapshot = await getDocs(q);
        let productID = [];
        querySnapshot.forEach((doc) => {
          productID.push(doc.id);
        });

        return { categoryId: doc.id, productIDs: productID }; // Return an object with categoryId and productIDs
      })
    );

    setDatas([s, values]);
    return [s, values];
  };

  const addCategorie = async () => {
    await addDoc(categorieRef, {
      name: label,
      color: labelColor,
      bg: labelBgColor,
      timeStamp: serverTimestamp(),
    })
      .then((id) => {
        return id;
      })
      .catch((e) => {
        return e;
      });
  };
  const editCategorie = async () => {
    await updateDoc(doc(db, DB_CATEGORIE, labelID), {
      name: label,
      color: labelColor,
      bg: labelBgColor,
      timeStamp: serverTimestamp(),
    })
      .then(() => {
        return "sucess";
      })
      .catch((e) => {
        return e;
      });
  };
  useEffect(() => {
    if (error) {
      return;
    }
    if (addAction) {
      addCategorie()
        .then((id) => {
          onSuccessAdded(id);
        })
        .catch((e) => {
          onFailAdded(e);
        })
        .finally(() => {
          onFinishAdded();
        });
    }
    if (editAction) {
      editCategorie()
        .then(() => {
          onSuccessEdit();
        })
        .catch((e) => {
          onFailEdit(e);
        })
        .finally(() => {
          onFinishEdit();
        });
    }
  }, [addAction, error, editAction]);

  useEffect(() => {
    const bachDelete = async () => {
      if (deleteAction) {
        const batch = writeBatch(db);
        selected.forEach((id) => {
          const docRef = doc(db, DB_CATEGORIE, id);
          batch.delete(docRef);
        });

        let products = categories.filter((c) => {
          return selected.includes(c.id);
        });

        let productIDs = [];
        products.forEach((p) => {
          productIDs.push(...p.productRef);
        });

        try {
          await Promise.all([
            await DeleteProducts(productIDs, db),
            await batch.commit(),
          ]);
          onSuccessDeleted();
        } catch (e) {
          onFailDeleted(e);
        } finally {
          onFinishDeleted();
        }
      }
    };
    bachDelete();
  }, [deleteAction]);

  function onSuccessDeleted() {
    setErrorType("success");
    setMessage("Categorie(s) Supprimer avec sucess!!");
    let dataRest = [...categories];
    dataRest = dataRest.filter((c) => {
      return !selected.includes(c.id);
    });
    setCategories(dataRest);
    setSelected([]);
  }
  function onFailDeleted(e) {
    setErrorType("error");
    setMessage("Impossible de supprimer les produits !!");
    console.log(e);
  }
  function onFinishDeleted() {
    setOpenDialog(false);
    setDeleteAction(false);
    setTimeout(() => {
      setOpen(true);
    }, 500);
  }

  useEffect(() => {
    const [s, record] = datas;
    const categoryData = [];
    const categorieDataLabel = {};

    s?.docs.forEach((doc, i) => {
      const categoryId = doc.id;
      const productIDs =
        record.find((r) => r.categoryId === categoryId)?.productIDs || [];

      categoryData.push({
        id: categoryId,
        record: productIDs.length,
        productRef: productIDs,
        ...doc.data(),
      });

      categorieDataLabel[categoryId] = {
        ...doc.data(),
        record: productIDs.length,
        productRef: productIDs,
      };
    });

    console.log(categoryData);
    setCategories(categoryData);
    setCategoriesList(categorieDataLabel);
  }, [datas]);

  function onSuccessAdded(id) {
    setErrorType("success");
    setMessage("Categorie ajouté avec sucess!!");
    const categorieData = {
      id: id,
      name: label,
      color: labelColor,
      bg: labelBgColor,
      record: 0,
    };
    let categorieListData = { ...categoriesList };
    categorieListData[id] = {
      name: label,
      color: labelColor,
      bgColor: labelBgColor,
      record: 0,
    };
    const datas = [...categories];
    datas.push(categorieData);

    setCategories(datas);
    setCategoriesList(categorieListData);
  }
  function onFailAdded(e) {
    setErrorType("error");
    setMessage("Impossible d'ajouter la categorie !!");
    console.log(e);
  }

  function onFinishAdded() {
    setOpenAddDialog(false);
    setAddAction(false);
    resetState();
    setTimeout(() => {
      setOpen(true);
    }, 500);
  }

  function resetState() {
    setLabel("Titre Categorie");
    setLabelColor("#fff");
    setLabelBgColor("#1976d2");
  }

  function handleChangeLabel(e) {
    setError(false);
    setLabel(e.target.value);
    if (openEditDialog) {
      categories.forEach((c) => {
        if (
          c.name === e.target.value &&
          c.name !== categoriesList[labelID].name
        ) {
          setError(true);
          return;
        }
      });
    } else {
      categories.forEach((c) => {
        if (c.name === e.target.value) {
          setError(true);
          return;
        }
      });
      return;
    }
  }

  function handleLabelColorChange(e) {
    setLabelColor(e.target.value);
  }

  function handleLabelBgColorChange(e) {
    setLabelBgColor(e.target.value);
  }

  function onSuccessEdit() {
    setErrorType("success");
    setMessage("Categorie modifier avec sucess!!");
    const categorieData = categories[index];
    categorieData.name = label;
    categorieData.color = labelColor;
    categorieData.bg = labelBgColor;

    const listCategorie = [...categories];
    listCategorie[index] = categorieData;

    const id = categories[index].id;
    let categorieListData = { ...categoriesList };
    categorieListData[id] = {
      name: label,
      color: labelColor,
      bg: labelBgColor,
    };
    setCategories(listCategorie);
    setCategoriesList(categorieListData);
  }
  function onFailEdit(e) {
    setErrorType("error");
    setMessage("Impossible de modifier la categorie !!");
    console.log(e);
  }

  function onFinishEdit() {
    setOpenEditDialog(false);
    setEditAction(false);
    resetState();
    setTimeout(() => {
      setOpen(true);
    }, 500);
  }

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <h1 className="title">EDITION CATEGORIE</h1>
      <hr />
      <Breadcrumbs aria-label="breadcrumb">
        <NavLink to="/admin/gestionVente" className="hover:underline">
          Gestion Vente
        </NavLink>
        <Typography color="text.primary">Categories</Typography>
      </Breadcrumbs>
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <EnhancedTableToolbar
            numSelected={selected.length}
            datas={categories}
            setOpenDialog={setOpenDialog}
            setOpenAddDialog={setOpenAddDialog}
          />
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="Liste produits"
              size={"medium"}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={categories.length}
                headCells={headCells}
              />
              <TableBody>
                {categories.map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          onClick={(event) => handleClick(event, row.id)}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </TableCell>
                      <TableCell align="left">{row.name}</TableCell>
                      <TableCell align="center">{row.record}</TableCell>
                      <TableCell align="left">
                        <Chip
                          label={row.name}
                          size="small"
                          color="primary"
                          sx={{
                            color: row.color,
                            bgcolor: row.bg,
                          }}
                        />
                      </TableCell>
                      <TableCell align="left">
                        <IconButton>
                          <EditIcon
                            onClick={() =>
                              (() => {
                                setIndex(index);
                                setLabel(row.name);
                                setLabelID(row.id);
                                setLabelColor(row.color);
                                setLabelBgColor(row.bg);
                                setOpenEditDialog(true);
                              })()
                            }
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {categories.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={headCells.length + 1} align="center">
                      Aucun Categorie enregistré
                      <Button
                        variant="contained"
                        sx={{ display: "block", m: "auto", mt: "10px" }}
                        onClick={() => setOpenAddDialog(true)}
                      >
                        Ajouter un categorie
                      </Button>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      <AlertDialog
        open={openDialog}
        setOpen={setOpenDialog}
        setAction={setDeleteAction}
        action={deleteAction}
        labelAction={"Supprimer"}
        colorAction={"error"}
        onCancel={() => setSelected([])}
      >
        <Alert severity="error">
          <AlertTitle>
            <strong>Attention !!!</strong>
          </AlertTitle>
          Souhaitez vous vraiment supprimer le{selected.length > 1 && "s"}{" "}
          categorie{selected.length > 1 && "s"}: <br />
          {selected.map((s, i) => (
            <b>
              {categoriesList[s]?.name}
              {i + 1 === selected.length ? "" : ","}
            </b>
          ))}
          <br />
          <b>
            {selected.reduce((acc, id) => {
              return acc + categoriesList[id]?.record;
            }, 0)}{" "}
          </b>
          produit(s) seront supprimé(s) !!
        </Alert>
      </AlertDialog>
      <AlertDialog
        open={openAddDialog}
        setOpen={setOpenAddDialog}
        setAction={setAddAction}
        action={error ? error : addAction}
        labelAction={"Ajouter"}
        colorAction={"success"}
        onCancel={() => setError(false)}
      >
        <div
          id="bgpreview"
          className="w-full h-[90px] flex items-center justify-center"
        >
          <Chip
            label={label}
            size="small"
            color="primary"
            sx={{
              color: labelColor,
              bgcolor: labelBgColor,
            }}
          />
        </div>
        <form className="w-full mt-2">
          <TextField
            id="filled-helperText"
            label="Nom"
            defaultValue={label}
            helperText="Titre de la categorie"
            variant="filled"
            className="w-full"
            onChange={handleChangeLabel}
            error={error}
          />
          <div className="flex w-full justify-between">
            <Button component="label" variant="outlined">
              <div className="flex w-full items-center space-x-2">
                <div
                  className="w-4 h-4 rounded-full"
                  style={{
                    backgroundColor: `${labelColor}`,
                  }}
                >
                  <input
                    className="colorInput"
                    type="color"
                    color={labelColor}
                    onChange={handleLabelColorChange}
                  />
                </div>
                <span>Coleur Texte</span>
              </div>
            </Button>
            <Button component="label" variant="outlined">
              <div className="flex w-full items-center space-x-2">
                <div
                  className="w-4 h-4 rounded-full"
                  style={{
                    backgroundColor: labelBgColor,
                  }}
                >
                  <input
                    className="colorInput"
                    type="color"
                    color={labelColor}
                    onChange={handleLabelBgColorChange}
                  />
                </div>
                <span>Coleur Arrière</span>
              </div>
            </Button>
          </div>
        </form>
      </AlertDialog>
      <AlertDialog
        open={openEditDialog}
        setOpen={setOpenEditDialog}
        setAction={setEditAction}
        action={error ? error : editAction}
        labelAction={"Modifier"}
        colorAction={"info"}
        onCancel={() => {
          (() => {
            setError(false);
            setLabel("");
          })();
        }}
      >
        <div
          id="bgpreview"
          className="w-full h-[90px] flex items-center justify-center"
        >
          <Chip
            label={label}
            size="small"
            color="primary"
            sx={{
              color: labelColor,
              bgcolor: labelBgColor,
            }}
          />
        </div>
        <form className="w-full mt-2">
          <TextField
            id="filled-helperText"
            label="Nom"
            defaultValue={label}
            helperText="Titre de la categorie"
            variant="filled"
            className="w-full"
            onChange={handleChangeLabel}
            error={error}
          />
          <div className="flex w-full justify-between">
            <Button component="label" variant="outlined">
              <div className="flex w-full items-center space-x-2">
                <div
                  className="w-4 h-4 rounded-full"
                  style={{
                    backgroundColor: `${labelColor}`,
                  }}
                >
                  <input
                    className="colorInput"
                    type="color"
                    color={labelColor}
                    onChange={handleLabelColorChange}
                  />
                </div>
                <span>Coleur Texte</span>
              </div>
            </Button>
            <Button component="label" variant="outlined">
              <div className="flex w-full items-center space-x-2">
                <div
                  className="w-4 h-4 rounded-full"
                  style={{
                    backgroundColor: labelBgColor,
                  }}
                >
                  <input
                    className="colorInput"
                    type="color"
                    color={labelColor}
                    onChange={handleLabelBgColorChange}
                  />
                </div>
                <span>Coleur Arrière</span>
              </div>
            </Button>
          </div>
        </form>
      </AlertDialog>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
      >
        <AlertBox
          //onClose={handleClose}
          severity={errorType}
          sx={{ width: "100%" }}
        >
          {message}
        </AlertBox>
      </Snackbar>
    </>
  );
}

export default CategoriePage;
